































































































































import { Vue, Component, Watch, Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import { ProfileStore } from '@/modules/profile/store'

@Component({
    // components: { SelectableAnswerComponent, SuggestionsAnswerComponent, TextAnswerComponent, PhoneAnswerComponent }
    // computed: mapState('chat', ['selectedQuestion']) this would work, but causes issues with the typing on the component
  })
export default class Profile extends Vue {
    name: 'Profile'
    profileStore = getModule(ProfileStore, this.$store)

    me = {
      lpq: {
        match: 300,
        contacts: 1000,
        quo: 10000,
        lives: 3
      },
      avatar: '',
      name: 'Jordi Muñoz Pérez',
      position: 'CEO',
      company: 'LEAD PRO QUO',
      label: 'Gamifier',
      location: {
        city: 'Mataró',
        province: 'Barcelona',
        country: 'Spain',
        position: {}
      },
      skills: {
        personal: ['Entrepeneur', 'Visionary', 'Nonconformist', 'Birrologist'],
        professional: ['Gamifier', 'Audiovisual', 'Speaker', 'Campeon'],
      },
      contacts: [{name: 'jorge pardillo', image: ''}, {name: 'jorge pardillo', image: ''}, {name: 'jorge pardillo', image: ''}]
    }

    getMatch () {
      return this.formatAmmount(this.me.lpq.match);
    }

    getLives () {
      return this.formatAmmount(this.me.lpq.lives);
    }

    getContacts () {
      return this.formatAmmount(this.me.lpq.contacts);
    }

    getQuos () {
      return this.formatAmmount(this.me.lpq.quo);
    }

    formatAmmount(ammount) {
      return this.nFormatter(ammount, 0);
    }

    nFormatter (num, digits) {
      var si = [
        { value: 1, symbol: "" },
        { value: 1E3, symbol: "k" },
        { value: 1E6, symbol: "M" },
        { value: 1E9, symbol: "G" },
        { value: 1E12, symbol: "T" },
        { value: 1E15, symbol: "P" },
        { value: 1E18, symbol: "E" }
      ];
      var rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
      var i;
      for (i = si.length - 1; i > 0; i--) {
        if (num >= si[i].value) {
          break;
        }
      }
      return (num / si[i].value).toFixed(digits).replace(rx, "$1") + si[i].symbol;
    }

    async created () {
    }

    destroyed () {
    }
}
